import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const viewAllAndroidBoxesGo = createAsyncThunk('viewAllAndroidBoxesGo',
    async (object, { dispatch }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingAndroidBoxesGo())

        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({...object})
        }

        fetch(domainUrl + `/showAllIptvGoDevices`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(viewAllAndroidBoxesGoResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                message.error(error) 
                dispatch(viewAllAndroidBoxesGoResponse([]))
            })
    }
)
export const viewAllPortalsIptvGo = createAsyncThunk('viewAllPortalsIptvGo',
    async (object, { dispatch }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingPortalsIptvGo())

        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({...object})
        }

        fetch(domainUrl + `/showAllIptvGoPortal`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(viewAllPortalsIptvGoResponse(result?.data))
                    dispatch(setPortalIptvGoPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                message.error(error) 
                dispatch(viewAllPortalsIptvGoResponse([]))
            })
    }
)


const BoxManagementGoSlice = createSlice({
    name: 'boxManagementGo',
    initialState: {
        data: null,
        loading: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        portals: null,
        portalsLoading: false,
        portalsPagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
    },
    reducers: {
        gettingAndroidBoxesGo: state => {
            state.loading=true
        },
        viewAllAndroidBoxesGoResponse: (state, action)=>{
            state.data= action.payload
            state.loading= false
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
        gettingPortalsIptvGo: state => {
            state.portalsLoading=true
        },
        viewAllPortalsIptvGoResponse: (state, action)=>{
            state.portals= action.payload
            state.portalsLoading= false
        },
        setPortalIptvGoPages:(state, action)=>{
            state.portalsPagination= action.payload
        },
    },
})
export const { 
    gettingAndroidBoxesGo, viewAllAndroidBoxesGoResponse, setPages,
    gettingPortalsIptvGo, viewAllPortalsIptvGoResponse, setPortalIptvGoPages
} = BoxManagementGoSlice.actions;
export default BoxManagementGoSlice.reducer;